import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { Conversation } from '../../models/conversation.model'
import type { Message } from '../../models/message.model'

export const realtimeMessagingEvents = eventGroup({
  source: 'Realtime Messaging',
  events: {
    conversationUpdate: type<{ conversation: Partial<Conversation> }>(),
    conversationReload: type<void>(),
    messageUpsert: type<{ message: Message }>(),
    otherProfileStartedTyping: type<void>(),
    otherProfileStoppedTyping: type<void>(),
  },
})
